<template>
  <md-dialog :md-active.sync="show" :md-fullscreen="false">
    <md-dialog-title>{{ text }}</md-dialog-title>
    <md-dialog-actions>
      <md-button class="md-primary" @click="close">Ok</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  props: ['text', 'show'],
  methods: {
    close: function () {
      this.$emit('closeError')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
